var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"videoWrap",class:['preview-viewer video-viewer', this.item.extension_category]},[_c('div',{staticClass:"video-js vjs-big-play-centered",attrs:{"id":"video-player-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }